<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="30%"
      @open="getList"
      @close="closeDialog">
      <el-main style="height: 400px">
        <el-table :data="chatroomList" height="100%" v-loading="loading">
          <el-table-column label="所在群">
            <template v-slot="scope">
              <div>
                <img :src=scope.row.avatar_url style="width: 30px; height: 30px" alt="">
                {{scope.row.room_nickname}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="团长">
            <template v-slot="scope">
              <div>
                {{scope.row.client_id}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="退群" align="center">
            <template v-slot="scope">
              <el-button type="danger" @click="postBotRemove(scope.row)">退群</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="footer">
        <el-pagination
          :total="totalCount"
          :page-size="pagesize"
          :current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from '../../../mixins/page'

export default {
  name: 'ChatroomList',
  mixins: [pageMixin],
  data () {
    return {
      botChatroomListUrl: this.getDomain() + 'bmbot/get_bot_chatroom_list',
      botRemoveUrl: this.getDomain() + 'bmbot/bot_remove_chatroom',
      chatroomList: [],
      loading: true
    }
  },
  props: {
    'dialogVisible': Boolean,
    'botUsername': String,
    'dialogTitle': String
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        bot_username: this.botUsername,
        page: this.page,
        pagesize: this.pagesize
      }
      let handle = res => {
        this.chatroomList = res.data.content.data
        this.totalCount = res.data.content.total_count
      }
      this.__axios(this.botChatroomListUrl, params, handle, () => { this.loading = false })
    },
    postBotRemove (row) {
      let params = {
        bot_username: this.botUsername,
        chatroomname: row.chatroomname
      }
      let handle = () => {
        this.$message.success('退群成功')
        this.getList()
      }
      this.__confirm('是否确认退群', this.__axios, [this.botRemoveUrl, params, handle])
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>
